/**
 * Convert a full image URL to a BFF proxy URL.
 * Call this only for images that need proxying (e.g., CMS images).
 * Images served via CDN (e.g., CloudFront) should use the original URL directly.
 */
export function toProxyUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  try {
    const parsed = new URL(url);
    return `/api/images?url=${encodeURIComponent(parsed.href)}`;
  } catch {
    // Design Decision: Silent null return is intentional — callers decide fallback behavior.
    return null;
  }
}
